/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { LoiCheckingRuleWrapper } from './loiCheckingRuleWrapper';

export interface LOICheckRule { 
    id?: string;
    name?: string;
    created?: Date;
    type?: LOICheckRule.TypeEnum;
    loiRule?: LoiCheckingRuleWrapper;
    idsXml?: string;
    deleted?: boolean;
}
export namespace LOICheckRule {
    export type TypeEnum = 'LOI' | 'IDS' | 'HYBRID' | 'AI';
    export const TypeEnum = {
        LOI: 'LOI' as TypeEnum,
        IDS: 'IDS' as TypeEnum,
        HYBRID: 'HYBRID' as TypeEnum,
        AI: 'AI' as TypeEnum
    };
}